import TeamForm from '../../components/TeamForm';
import TableEditor from '../../components/TableEditor';
import { Table } from '../../components';
import { createOrmActions, editorPropTypes } from '../../components/common';

import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';

const TeamsEditorHeader = ({ children }) => (
  <Table.Row>
    <Table.HeaderCell>Name</Table.HeaderCell>
    <Table.HeaderCell>Abbreviation</Table.HeaderCell>
    {children}
  </Table.Row>
);

const TeamsEditorRow = ({ row, children }) => (
  <Table.Row>
    <Table.Cell>{row.name}</Table.Cell>
    <Table.Cell>{row.abbreviation || ''}</Table.Cell>
    {children}
  </Table.Row>
);

const TeamsEditor = ({ id, teams, actions, meta }) => {
  const defaultValues = {
    uuid: uuid(),
    name: '',
    abbreviation: '',
  };

  const rows = teams.map(team => ({
    ...team,
    key: team.uuid,
    title: team.name,
    description: `team ${team.name}`,
    currentValues: {
      uuid: team.uuid || '',
      name: team.name || '',
      abbreviation: team.abbreviation || '',
    },
  }));

  return (
    <TableEditor
      id={id}
      Header={TeamsEditorHeader}
      Row={TeamsEditorRow}
      rows={rows}
      Form={TeamForm}
      defaultValues={defaultValues}
      actions={createOrmActions(actions, rows)}
      meta={meta}
    />
  );
};

TeamsEditor.propTypes = {
  ...editorPropTypes,
  teams: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default TeamsEditor;



// WEBPACK FOOTER //
// ./src/pages/Entry/TeamsEditor.js